import React, { useEffect, useState } from 'react';
import { getAllMentorStudents } from '../../services/thesisService';
import { Link } from "react-router-dom";
import "./datatable.scss"
import { DataGrid } from '@mui/x-data-grid';
import axiosInstance from '../../api/axios';
import { toast } from 'react-toastify';


export const MentorStudentList=({instructorId})=> {
    const [students, setStudents] = useState([]);
    const fetchStudents = async (id) => {
        try {
            const data = await getAllMentorStudents(id);
           // console.log(data);
            setStudents(data.data);
        } catch (err) {
        } 
    };


    useEffect(() => {      

        fetchStudents(instructorId);
    }, []);


    const columns = React.useMemo(
        () => [
            { field: 'enrollment_number', headerName: 'Enrollment No.', width: 170 },
            { field: 'student_name', headerName: 'Student Name', width: 170 },
            { field: 'thesis_title', headerName: 'Thesis Title', width: 170 }
        ],
        []
    );

 
   

    return (
        <div className="datatable" >

      
      <DataGrid 
      rows={students}
      columns={columns}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[5, 10]}
      //checkboxSelection
    />
  </div>
    );
}

